module.exports = {
      id: "share-link-gnreach-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#share-link-gnreach",
      toString: function () {
        return this.url;
      }
    }